import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import GlobalSecurityStaff from "../../components/Admin/Global-security"

const GlobalSecurity = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Global Securities | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <GlobalSecurityStaff />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default GlobalSecurity
